import formatTableJson from '@/config/tableComponentParams.js'
import { redColor } from '@/style/var.scss'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'code',
    label: i18n.t('Device.deviceCode')
  },
  // {
  //   filed: 'productName',
  //   label: '产品型号'
  // },
  // {
  //   filed: 'factoryArea',
  //   label: '工厂区域'
  // },
  {
    filed: 'reason',
    label: i18n.t('Device.reason'),
    renderFn(h, row) {
      return <span style={{ color: redColor }}>{row.reason || '-'}</span>
    }
  }
])
